import { useSnackbar } from "notistack";
import React, { useRef, useState, useEffect } from "react";
import CustomModal from "../main_comps/custom_modal";
import { GrFormClose } from "react-icons/gr";
// import { Document } from "react-pdf";

import {
  Eyelight,
  Upwardarrow
} from "../../../utility/constants/assetsManager";
import { bgColor } from "../../../utility/constants/colorManager";
import ViewMoreApproval from "./approval_comps/ViewMoreApproval";
import ReactPlayer from "react-player";

function CustomUploadField2({
  style,
  title,
  onChange,
  accept = ".pdf",
  isDownloadFileRequired = false,
  onClickRemove,
  value,
  document,
  customIcon,
  imageTypeArray = ["png", "jpg", "img", "pdf", "image", "jpeg", "mp4"],
  filesize = 2,
  containerStyle,
  textStyles
}) {
  const [file, setFile] = useState({});
  const [fileName, setFileName] = useState("");
  const [modal, setModal] = useState(false);
  const [state, setState] = useState("");

  const fontStyle = {
    fontSize: 12,
    fontWeight: "500",
    margin: "5px 0px",
    marginLeft: 5,
    padding: 0
  };

  function getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }

  const { enqueueSnackbar } = useSnackbar();
  const ref = useRef();

  const blobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  const createBlobFromFile = async (input, type) => {
    let fileUrl = URL.createObjectURL(input);

    // fetch(fileUrl)
    //   .then((response) => response.blob())
    //   .then((blob) => {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //       // Process the file data here
    //       const fileData = reader.result;
    //       // Perform actions with the file data

    //

    //       const pdfBlob = new Blob([fileData], { type: "application/pdf" });

    //       const pdfDataUrl = URL.createObjectURL(pdfBlob);
    //       // Open a new window and display the PDF
    //       const newWindow = window.open();
    //       newWindow.document.write(
    //         `<iframe src="${pdfDataUrl}" width="100%" height="100%"></iframe>`
    //       );
    //     };
    //     reader.readAsArrayBuffer(blob);
    //   })
    //   .catch((error) => {
    //     // Handle any errors that occur during file fetching or processing
    //
    //   });

    let reader = new FileReader();

    reader.readAsArrayBuffer(file ? file : value);
    //converting array buffer to base64
    reader.onload = async () => {
      let tempFile = new Blob([reader.result], {
        type: type
      });
      //to convert blob to base64
      let temp = await blobToBase64(tempFile);

      if (type === "application/pdf") {
        let pdfWindow = window.open("");
        var bodyMargin = "<style>body {margin: 0px !important; }</style>";
        // To show pdf in next tabs
        pdfWindow.document.write("<html><head>");
        pdfWindow.document.write(`${bodyMargin}</head><body>`);
        pdfWindow.document.write(
          `<iframe width='100%' height='100%' src=${encodeURI(temp)}></iframe>`
        );

        pdfWindow.document.write("</body></html>");
        pdfWindow.document.close();
      } else if (
        type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        let pdfWindow = window.open("");
        var bodyMargin = "<style>body {margin: 0px !important; }</style>";
        // To show pdf in next tabs
        pdfWindow.document.write("<html><head>");
        pdfWindow.document.write(`${bodyMargin}</head><body>`);
        pdfWindow.document.write(
          `<iframe width='100%' height='100%' src=${encodeURI(temp)}></iframe>`
        );
        pdfWindow.document.write("</body></html>");
        pdfWindow.document.close();
      } else {
        setState(temp);
        setModal(true);
      }
    };
  };

  useEffect(() => {
    setFile(value);
    if (value) {
      setFileName(value?.name);
    } else {
      setFileName("");
    }
  }, [value]);

  return (
    <div
      style={{
        backgroundColor: "rgba(111, 108, 255, 0.05)",
        alignSelf: "center",
        height: 50,
        width: "100%",
        boxShadow: "none",
        outline: "none",
        borderRadius: 5,
        boxSizing: "border-box",
        width: "30%",
        marginBottom: "30px",
        minWidth: "320px",
        maxWidth: "320px",
        ...style
      }}
    >
      {title && (
        <p
          style={{
            ...fontStyle
          }}
        >
          {title}
        </p>
      )}

      <div
        style={{
          height: 50,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          width: "100%",
          padding: "0px 5px",
          ...containerStyle
        }}
        onClick={() => {
          if (fileName === "") {
            ref.current.click();
          } else {
          }
        }}
      >
        {fileName ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between"
            }}
          >
            <p
              style={{
                ...fontStyle,
                fontWeight: "400",
                fontSize: "16px"
              }}
              title={fileName}
            >
              {fileName?.length > 15
                ? fileName?.slice(0, 15) + "..."
                : fileName}
            </p>

            <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
              <GrFormClose
                style={{
                  width: "24px",
                  height: "24px"
                }}
                onClick={() => {
                  setFile({});
                  setFileName("");
                  onClickRemove();
                }}
              />

              <Eyelight
                style={{
                  minWidth: 24,
                  height: 24,
                  marginLeft: "15%",
                  cursor: "pointer"
                }}
                onClick={() => {
                  createBlobFromFile(file, file ? file.type : value.type);
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%"
            }}
          >
            <input
              style={{
                width: "100%",
                height: "100%",
                zIndex: -1,
                position: "absolute"
              }}
              type="file"
              ref={ref}
              onClick={(event) => {
                event.target.value = "";
              }}
              onChange={(e) => {
                let size = parseFloat(
                  e.target.files[0].size / (1024 * 1024)
                ).toFixed(2);

                if (
                  imageTypeArray.includes(
                    getFileExtension(e.target.files[0]?.name)
                  )
                ) {
                  if (size <= filesize) {
                    setFile(e.target.files[0]);
                    setFileName(e.target.files[0]?.name);
                    onChange(e.target.files[0]);
                  } else {
                    enqueueSnackbar(
                      "Uploaded file exceeded maximum file size",
                      {
                        variant: "error"
                      }
                    );
                  }
                } else {
                  enqueueSnackbar(
                    "Please upload only" + " " + imageTypeArray[0],
                    {
                      variant: "error"
                    }
                  );
                }

                //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
              }}
              accept={accept}
            />

            {/* <img
              src={Upwardarrow}
              style={{
                width: 20,
                height: 20,
              }}
            /> */}
            <p style={{ ...textStyles }}>{document}</p>

            {customIcon}
            {/* <p
              style={{
                ...fontStyle,
                fontWeight: "400",
              }}
            >
              Click here to upload
            </p> */}
          </div>
        )}
      </div>

      {modal && (
        <>
          <CustomModal
            open={modal}
            onClose={() => {
              setModal(false);
            }}
            isHeaderRequired={true}
            containerStyle={{
              height: 400,
              width: 500
            }}
          >
            {accept === ".png" ? (
              <img
                style={{ height: 350, width: 450, margin: "auto" }}
                src={state}
              />
            ) : (
              <ReactPlayer
                url={state}
                playing={true}
                controls={true}
                width="450px"
                height="350px"
                style={{ margin: "auto" }}
              />
            )}
          </CustomModal>
        </>
      )}

      {isDownloadFileRequired && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center"
          }}
        >
          <img
            src={Eyelight}
            style={{
              width: 14,
              height: 14,
              marginTop: 5,
              cursor: "pointer"
            }}
          />

          {/* <p
            style={{
              ...fontStyle,
              fontWeight: "400",
              cursor: "pointer",
            }}
          >
            Download sample file
          </p> */}
        </div>
      )}
    </div>
  );
}

export default CustomUploadField2;
